var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-navbar",
        {
          attrs: { id: "header", type: "light", variant: "light", sticky: "" }
        },
        [
          _c("b-navbar-nav", [
            _c("h4", { staticClass: "mb-0" }, [_vm._v(_vm._s(_vm.title))])
          ]),
          _vm._v(" "),
          _c(
            "b-navbar-nav",
            { staticClass: "ml-auto" },
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c("export-sidebar", {
                        attrs: {
                          "sidebar-id": "sidebar-organizations-export",
                          "storage-key": "sidebar_organizations_export",
                          columns: _vm.exportableFields,
                          "data-to-export": _vm.dataToExport,
                          "data-mapper": _vm.mapOrganizationForExport,
                          "file-name": "Organizations.xlsx",
                          "sheet-name": "Organizations",
                          "is-busy": _vm.isBusy,
                          "items-count": _vm.totalRows
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { cols: "auto" } },
                    [
                      _c(
                        "b-button",
                        {
                          directives: [
                            {
                              name: "b-toggle",
                              rawName: "v-b-toggle.sidebar-fields",
                              modifiers: { "sidebar-fields": true }
                            }
                          ],
                          staticClass: "mr-2",
                          attrs: {
                            id: "table-settings",
                            size: "sm",
                            variant: "warning"
                          }
                        },
                        [_c("font-awesome-icon", { attrs: { icon: "cog" } })],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-tooltip",
                        {
                          attrs: {
                            target: "table-settings",
                            triggers: "hover",
                            variant: "warning",
                            noninteractive: ""
                          }
                        },
                        [_vm._v("\n            Колонки\n          ")]
                      ),
                      _vm._v(" "),
                      _vm.canEditOrganizations()
                        ? _c(
                            "b-btn",
                            {
                              attrs: {
                                size: "sm",
                                variant: "success",
                                disabled: _vm.isBusy
                              },
                              on: {
                                click: function($event) {
                                  return _vm.showModal(null, false)
                                }
                              }
                            },
                            [
                              _vm.isBusy
                                ? _c("b-spinner", { attrs: { small: "" } })
                                : _vm._e(),
                              _vm._v(" "),
                              _c("font-awesome-icon", {
                                staticClass: "mr-1",
                                attrs: { icon: "plus" }
                              }),
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.$t("message.organizations.importHand")
                                  ) +
                                  "\n          "
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("filters-drawer", {
        attrs: {
          query: _vm.filters.query,
          "is-busy": _vm.isBusy,
          "hide-search-button": ""
        },
        on: {
          "update:query": function($event) {
            return _vm.$set(_vm.filters, "query", $event)
          },
          submit: _vm.onSearch
        }
      }),
      _vm._v(" "),
      _c("b-table", {
        ref: "organizations",
        staticClass: "mb-0 text-small",
        attrs: {
          id: "organizations",
          "sticky-header": "",
          "head-variant": "light",
          "tbody-tr-class": _vm.tbodyRowClass,
          "select-mode": "multi",
          striped: "",
          small: "",
          responsive: "",
          "show-empty": "",
          "empty-text": _vm.$t("message.common.emptyTable"),
          busy: _vm.isBusy,
          items: _vm.items,
          fields: _vm.renderedFields,
          "no-provider-filtering": "",
          "no-provider-paging": "",
          "no-provider-sorting": "",
          "no-local-sorting": ""
        },
        on: {
          "update:busy": function($event) {
            _vm.isBusy = $event
          },
          "sort-changed": _vm.sortChanged,
          "row-clicked": _vm.onRowClicked,
          "row-dblclicked": _vm.onRowDblClicked
        },
        scopedSlots: _vm._u([
          {
            key: "table-busy",
            fn: function() {
              return [
                _c(
                  "div",
                  { staticClass: "text-center text-success my-2" },
                  [
                    _c("b-spinner", { staticClass: "align-middle" }),
                    _vm._v(" "),
                    _c("strong", [_vm._v("Загрузка")])
                  ],
                  1
                )
              ]
            },
            proxy: true
          },
          {
            key: "head(selected)",
            fn: function(row) {
              return [
                _c("b-form-checkbox", {
                  staticClass: "mx-1",
                  attrs: { indeterminate: _vm.indeterminate, size: "md" },
                  on: { change: _vm.selectPageRows },
                  model: {
                    value: _vm.allSelected,
                    callback: function($$v) {
                      _vm.allSelected = $$v
                    },
                    expression: "allSelected"
                  }
                })
              ]
            }
          },
          {
            key: "cell(selected)",
            fn: function(row) {
              return [
                row.item.selected
                  ? [
                      _c("span", { attrs: { "aria-hidden": "true" } }, [
                        _vm._v("✓")
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "sr-only" }, [
                        _vm._v("Выбрана")
                      ])
                    ]
                  : [
                      _c("span", [_vm._v(" ")]),
                      _vm._v(" "),
                      _c("span", { staticClass: "sr-only" }, [
                        _vm._v("Не выбрана")
                      ])
                    ]
              ]
            }
          },
          {
            key: "cell(address)",
            fn: function(row) {
              return [
                row.item.address.length < 50
                  ? _c("div", [_vm._v(_vm._s(row.item.address))])
                  : _c("div", [
                      _vm._v(_vm._s(row.item.address.substring(0, 50) + ".."))
                    ])
              ]
            }
          },
          {
            key: "cell(action)",
            fn: function(row) {
              return [
                _c(
                  "b-dropdown",
                  {
                    attrs: { size: "sm", "no-caret": "" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "button-content",
                          fn: function() {
                            return [
                              _c("font-awesome-icon", {
                                attrs: { icon: "ellipsis-v" }
                              })
                            ]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      true
                    )
                  },
                  [
                    _vm._v(" "),
                    _c(
                      "b-dropdown-item-button",
                      {
                        attrs: { variant: "success" },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.showModal(row.item.id, true)
                          }
                        }
                      },
                      [
                        _c("font-awesome-icon", { attrs: { icon: "eye" } }),
                        _vm._v("\n          Смотреть\n        ")
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.canEditOrganizations()
                      ? _c(
                          "b-dropdown-item-button",
                          {
                            attrs: { variant: "primary" },
                            on: {
                              click: function($event) {
                                return _vm.showModal(row.item.id, false)
                              }
                            }
                          },
                          [
                            _c("font-awesome-icon", {
                              attrs: { icon: "edit" }
                            }),
                            _vm._v("\n          Редактировать\n        ")
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.canEditOrganizations()
                      ? _c(
                          "b-dropdown-item-button",
                          {
                            attrs: { variant: "danger" },
                            on: {
                              click: function($event) {
                                return _vm.onRemove(row)
                              }
                            }
                          },
                          [
                            _c("font-awesome-icon", {
                              attrs: { icon: "trash" }
                            }),
                            _vm._v("\n          Удалить\n        ")
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                )
              ]
            }
          },
          {
            key: "cell(phone)",
            fn: function(row) {
              return [
                _c("a", { attrs: { href: _vm.telUrl(row.item.phone) } }, [
                  _vm._v(_vm._s(_vm.phoneString(row.item.phone)))
                ])
              ]
            }
          }
        ])
      }),
      _vm._v(" "),
      _c("pagination-footer", {
        attrs: { "total-rows": _vm.totalRows, "per-page": _vm.perPage },
        on: {
          "update:perPage": function($event) {
            _vm.perPage = $event
          },
          "update:per-page": function($event) {
            _vm.perPage = $event
          },
          "page-click": _vm.onPagination,
          "per-page-change": _vm.onPerPageChange
        },
        scopedSlots: _vm._u([
          {
            key: "footer-update",
            fn: function() {
              return [
                _vm.selected.length > 0
                  ? _c(
                      "b-row",
                      { attrs: { "align-h": "between", "align-v": "center" } },
                      [
                        _c(
                          "b-col",
                          {
                            staticClass: "mr-auto text-small",
                            attrs: { cols: "auto" }
                          },
                          [
                            _vm._v("\n          Выбрано: "),
                            _c("b", [_vm._v(_vm._s(_vm.selected.length))])
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.selected.length > 0 ? _c("hr") : _vm._e()
              ]
            },
            proxy: true
          }
        ])
      }),
      _vm._v(" "),
      _c("organization", {
        ref: "organization",
        on: { refresh: _vm.getItems, "modal-closed": _vm.onModalClosed }
      }),
      _vm._v(" "),
      _c("dynamic-tables", {
        attrs: {
          "storage-key": "organizations_columns",
          "sidebar-fields": "sidebar-fields",
          "fields-model": _vm.fields,
          fieldKey: "name"
        },
        on: {
          "update:fieldsModel": function($event) {
            _vm.fields = $event
          },
          "update:fields-model": function($event) {
            _vm.fields = $event
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6a1cacd1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a1cacd1","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Organizations/Organizations.vue
// module id = null
// module chunks = 